import PageHeader from "@/components/site/PageHeader";
import { Outreach } from "@/components/site/Sections";
import { CTABand } from "@/components/site/AboutSections";
import { usePageMeta } from "@/lib/usePageMeta";

export default function OutreachPage() {
  usePageMeta(
    "Community Outreach & Impact",
    "RE//FORM PLACE CHI GO Teams serve Chicago through food distribution, holiday drives, street evangelism, and the WCEP workforce program. See our 2025 impact.",
  );
  return (
    <div data-testid="outreach-page">
      <PageHeader
        crumb="Outreach"
        eyebrow="Community Outreach"
        title="The Church For"
        accent="The City."
        intro="GO Teams take the love of Jesus outside our walls — door to door, block by block — through food and supply distribution, holiday drives, prayer walks, and partnerships across Chicago."
        image="/outreach/englewood-serving.jpg"
        imagePosition="center 40%"
      />
      <Outreach />
      <CTABand
        eyebrow="Serve With Us"
        title="Join A GO Team"
        text="Whether you can give a Saturday morning or a season, there is a place for you on the streets with us."
        primary={{ to: "/serve", label: "Volunteer" }}
        secondary={{ to: "/give", label: "Support Outreach" }}
      />
    </div>
  );
}
